import React, { useCallback, useEffect, useMemo, useState } from "react";

import apiClient from "../../../services/apiClient";

// 숫자를 세는 일은 서버가 한다. 여기서는 받아서 그리기만 한다.
const SeminarPage = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [keyword, setKeyword] = useState("");
  const [onlyMarketing, setOnlyMarketing] = useState(false);
  const [onlyPartner, setOnlyPartner] = useState(false);

  const load = useCallback(() => {
    apiClient
      .get("/api/v1/echo/admin/seminar", { withAuth: true })
      .then((response) => setData(response.data))
      .catch((caught) =>
        setError(caught.response?.data?.error || "명단을 불러오지 못했습니다.")
      );
  }, []);

  useEffect(load, [load]);

  const rowList = useMemo(() => {
    if (!data) return [];
    const text = keyword.trim().toLowerCase();
    return data.rows.filter((row) => {
      if (onlyMarketing && !row.marketing_agreed) return false;
      if (onlyPartner && !row.partner_academy) return false;
      if (!text) return true;
      return [
        row.parent_name, row.phone, row.region,
        row.partner_academy, row.email, row.question,
      ]
        .join(" ")
        .toLowerCase()
        .includes(text);
    });
  }, [data, keyword, onlyMarketing, onlyPartner]);

  // 엑셀로 넘길 일이 반드시 생긴다. 붙여넣기 쉽게 탭으로 뽑는다.
  const copyAsTable = () => {
    const header = [
      "순번", "학부모", "전화", "학년", "지역",
      "협력학원", "이메일", "학원안내", "신청일시", "질문",
    ].join("\t");
    const body = rowList
      .map((row) =>
        [
          row.seat_number, row.parent_name, row.phone, row.child_grade,
          row.region, row.partner_academy, row.email,
          row.marketing_agreed ? "희망" : "",
          row.created_at.slice(0, 16).replace("T", " "),
          (row.question || "").replace(/\s+/g, " "),
        ].join("\t")
      )
      .join("\n");
    navigator.clipboard
      .writeText(`${header}\n${body}`)
      .then(() => alert(`${rowList.length}명을 복사했어요. 엑셀에 붙여넣으세요.`))
      .catch(() => alert("복사하지 못했어요."));
  };

  if (error) return <p style={{ padding: "26px" }}>{error}</p>;
  if (!data) return <p style={{ padding: "26px" }}>불러오는 중...</p>;

  const { summary } = data;
  const filled = summary.capacity
    ? Math.round((summary.total / summary.capacity) * 100)
    : 0;

  return (
    <div style={{ padding: "22px 20px 60px", maxWidth: "1180px", margin: "0 auto" }}>
      <h2 style={{ fontSize: "1.15rem", fontWeight: 800, margin: "0 0 4px" }}>
        학부모 ZOOM 설명회 신청
      </h2>
      <p style={{ fontSize: "0.85rem", color: "#7A8490", margin: "0 0 18px" }}>
        10월 5일(월) 저녁 10시 · 여기 숫자가 실제입니다. 신청 페이지에 보이는 '남은 자리'는
        시간이 지나면 함께 줄도록 해 둔 값이라 아래와 다릅니다.<br />
        신청 페이지는{" "}
        <a href="https://api.submitmyhomework.kr/seminar/" target="_blank" rel="noreferrer"
           style={{ color: "#00A396" }}>
          api.submitmyhomework.kr/seminar/
        </a>
      </p>

      <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginBottom: "16px" }}>
        <Stat label="실제 신청" value={`${summary.total}명`} note={`정원 ${summary.capacity}명`} strong />
        <Stat label="실제 남은 자리" value={`${summary.left}석`} note={`${filled}% 찼어요`} />
        <Stat label="학원 안내 희망" value={`${summary.marketing_count}명`} note="선택 동의" />
        <Stat label="협력학원 재원" value={`${summary.partner_count}명`} note="본인 기재" />
        <Stat label="사전 질문" value={`${summary.question_count}건`} note="아래에 모아 둠" />
      </div>

      <VisitChart summary={data.visit_summary} items={data.visit_list} />

      <Bars title="학년" items={summary.grade_list.filter((one) => one.count > 0)}
            nameKey="grade" empty="아직 신청이 없어요." />
      <Bars title="지역 (앞말 기준)" items={summary.region_list}
            nameKey="region" empty="아직 지역을 적은 분이 없어요." />

      <div style={{ display: "flex", gap: "8px", alignItems: "center",
                    flexWrap: "wrap", margin: "22px 0 10px" }}>
        <input
          value={keyword}
          onChange={(event) => setKeyword(event.target.value)}
          placeholder="이름, 전화, 지역, 학원, 질문 검색"
          style={{ flex: "1 1 240px", minWidth: 0, border: "1px solid #E6EDEC",
                   borderRadius: "9px", padding: "8px 12px",
                   fontFamily: "inherit", fontSize: "0.86rem" }}
        />
        <Toggle on={onlyMarketing} onClick={() => setOnlyMarketing(!onlyMarketing)}>
          학원 안내 희망만
        </Toggle>
        <Toggle on={onlyPartner} onClick={() => setOnlyPartner(!onlyPartner)}>
          협력학원 재원만
        </Toggle>
        <button type="button" onClick={copyAsTable}
          style={{ border: "none", background: "#0E141B", color: "#fff", borderRadius: "9px",
                   padding: "8px 15px", fontFamily: "inherit", fontSize: "0.84rem",
                   fontWeight: 700, cursor: "pointer" }}>
          엑셀로 복사 ({rowList.length})
        </button>
        <button type="button" onClick={load}
          style={{ border: "1px solid #E6EDEC", background: "#fff", borderRadius: "9px",
                   padding: "8px 14px", fontFamily: "inherit", fontSize: "0.84rem",
                   cursor: "pointer" }}>
          새로고침
        </button>
      </div>

      <div style={{ overflowX: "auto", border: "1px solid #E6EDEC", borderRadius: "10px" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.83rem",
                        whiteSpace: "nowrap" }}>
          <thead>
            <tr style={{ background: "#F6F8F8", textAlign: "left" }}>
              {["순번", "학부모", "전화", "학년", "지역", "협력학원", "이메일",
                "학원안내", "신청일시"].map((text) => (
                <th key={text} style={thStyle}>{text}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rowList.map((row) => (
              <tr key={row.id} style={{ borderTop: "1px solid #EEF2F1" }}>
                <td style={{ ...tdStyle, color: "#7A8490" }}>{row.seat_number}</td>
                <td style={{ ...tdStyle, fontWeight: 700 }}>{row.parent_name}</td>
                <td style={tdStyle}>{row.phone}</td>
                <td style={tdStyle}>{row.child_grade}</td>
                <td style={tdStyle}>{row.region || "-"}</td>
                <td style={tdStyle}>{row.partner_academy || "-"}</td>
                <td style={tdStyle}>{row.email}</td>
                <td style={tdStyle}>{row.marketing_agreed ? "희망" : "-"}</td>
                <td style={{ ...tdStyle, color: "#7A8490" }}>
                  {row.created_at.slice(5, 16).replace("T", " ")}
                </td>
              </tr>
            ))}
            {!rowList.length && (
              <tr>
                <td colSpan={9} style={{ ...tdStyle, textAlign: "center", color: "#7A8490" }}>
                  {data.rows.length ? "조건에 맞는 신청이 없어요." : "아직 신청이 없어요."}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {Boolean(data.question_list.length) && (
        <>
          <h3 style={{ fontSize: "0.98rem", fontWeight: 800, margin: "30px 0 10px" }}>
            사전 질문 {data.question_list.length}건
          </h3>
          <div style={{ display: "flex", flexDirection: "column", gap: "9px" }}>
            {data.question_list.map((one) => (
              <div key={one.seat_number}
                   style={{ border: "1px solid #E6EDEC", borderRadius: "10px",
                            padding: "12px 14px", background: "#FBFCFC" }}>
                <div style={{ fontSize: "0.78rem", color: "#7A8490", marginBottom: "5px" }}>
                  {one.seat_number}번 · {one.parent_name} · {one.child_grade}
                </div>
                <div style={{ fontSize: "0.88rem", whiteSpace: "pre-wrap", lineHeight: 1.65 }}>
                  {one.question}
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

const thStyle = { padding: "10px 12px", fontWeight: 700, color: "#3A434E" };
const tdStyle = { padding: "10px 12px", color: "#0E141B" };

const Stat = ({ label, value, note, strong }) => (
  <div style={{ flex: "1 1 150px", border: "1px solid #E6EDEC", borderRadius: "11px",
                padding: "13px 15px", background: strong ? "#0E141B" : "#fff",
                color: strong ? "#fff" : "#0E141B" }}>
    <div style={{ fontSize: "0.74rem", color: strong ? "#9AA79F" : "#7A8490", fontWeight: 700 }}>
      {label}
    </div>
    <div style={{ fontSize: "1.45rem", fontWeight: 800, margin: "2px 0 1px" }}>{value}</div>
    <div style={{ fontSize: "0.74rem", color: strong ? "#9AA79F" : "#7A8490" }}>{note}</div>
  </div>
);

// 막대는 가장 많은 칸을 기준으로 그린다. 정원 기준으로 그리면 초반에 전부 실선처럼 보인다.
const Bars = ({ title, items, nameKey, empty }) => {
  const top = Math.max(...items.map((one) => one.count), 1);
  return (
    <div style={{ marginTop: "14px" }}>
      <div style={{ fontSize: "0.8rem", fontWeight: 700, color: "#3A434E", marginBottom: "7px" }}>
        {title}
      </div>
      {items.length ? (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "7px" }}>
          {items.map((one) => (
            <div key={one[nameKey]}
                 style={{ flex: "1 1 96px", border: "1px solid #E6EDEC",
                          borderRadius: "8px", padding: "8px 10px", background: "#fff" }}>
              <div style={{ display: "flex", justifyContent: "space-between",
                            fontSize: "0.8rem", fontWeight: 700 }}>
                <span>{one[nameKey]}</span>
                <span>{one.count}</span>
              </div>
              <div style={{ height: "4px", background: "#EEF2F1", borderRadius: "2px",
                            marginTop: "6px" }}>
                <div style={{ width: `${(one.count / top) * 100}%`, height: "100%",
                              background: "#00A396", borderRadius: "2px" }} />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p style={{ fontSize: "0.82rem", color: "#7A8490", margin: 0 }}>{empty}</p>
      )}
    </div>
  );
};

// 시간대별 조회수. 막대가 48개라 표로 그리면 길어져서 가로 막대그래프로 둔다.
const VisitChart = ({ summary, items }) => {
  const [hours, setHours] = useState(24);
  const shown = items.slice(-hours);
  const top = Math.max(...shown.map((one) => one.count), 1);

  return (
    <div style={{ marginTop: "18px", border: "1px solid #E6EDEC",
                  borderRadius: "11px", padding: "14px 15px", background: "#fff" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between",
                    flexWrap: "wrap", gap: "8px", marginBottom: "10px" }}>
        <div>
          <span style={{ fontSize: "0.86rem", fontWeight: 800 }}>시간대별 조회수</span>
          <span style={{ fontSize: "0.76rem", color: "#7A8490", marginLeft: "8px" }}>
            누적 {summary.total}회 · 오늘 {summary.today}회 · 모바일 {summary.mobile_percent}%
          </span>
        </div>
        <div style={{ display: "flex", gap: "6px" }}>
          {[12, 24, 48].map((one) => (
            <button key={one} type="button" onClick={() => setHours(one)}
              style={{ border: `1px solid ${hours === one ? "#00A396" : "#E6EDEC"}`,
                       background: hours === one ? "#E6F7F5" : "#fff",
                       color: hours === one ? "#00796E" : "#7A8490",
                       borderRadius: "999px", padding: "4px 11px", fontFamily: "inherit",
                       fontSize: "0.76rem", fontWeight: 700, cursor: "pointer" }}>
              {one}시간
            </button>
          ))}
        </div>
      </div>

      {summary.total ? (
        <div style={{ display: "flex", alignItems: "flex-end", gap: "2px",
                      height: "108px", overflowX: "auto", paddingBottom: "2px" }}>
          {shown.map((one) => (
            <div key={one.hour} title={`${one.hour} · ${one.count}회 (모바일 ${one.mobile})`}
                 style={{ flex: "1 0 10px", display: "flex", flexDirection: "column",
                          alignItems: "center", gap: "3px", minWidth: "10px" }}>
              <span style={{ fontSize: "0.62rem", color: "#7A8490",
                             visibility: one.count ? "visible" : "hidden" }}>
                {one.count}
              </span>
              <div style={{ width: "100%", height: `${(one.count / top) * 74}px`,
                            minHeight: one.count ? "3px" : "1px",
                            background: one.count ? "#00A396" : "#EEF2F1",
                            borderRadius: "2px 2px 0 0" }} />
              <span style={{ fontSize: "0.58rem", color: "#9AA5AD",
                             writingMode: "vertical-rl", height: "30px" }}>
                {one.hour.slice(-3)}
              </span>
            </div>
          ))}
        </div>
      ) : (
        <p style={{ fontSize: "0.82rem", color: "#7A8490", margin: 0 }}>
          아직 방문 기록이 없어요.
        </p>
      )}
    </div>
  );
};

const Toggle = ({ on, onClick, children }) => (
  <button type="button" onClick={onClick}
    style={{ border: `1px solid ${on ? "#00A396" : "#E6EDEC"}`,
             background: on ? "#E6F7F5" : "#fff", color: on ? "#00796E" : "#3A434E",
             borderRadius: "999px", padding: "8px 14px", fontFamily: "inherit",
             fontSize: "0.82rem", fontWeight: 700, cursor: "pointer" }}>
    {children}
  </button>
);

export default SeminarPage;
